const BASE = process.env.VUE_APP_PUBLIC_MAIN_URL

export { BASE }
